module.exports = __webpack_public_path__ + "static/img/激活成功.a815217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/激活成功.png
// module id = 9jD3
// module chunks = 1